export default "__VITE_ASSET__DTamZWeL__"